/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { TPlanningMethodology, TReorderStrategy } from 'volta/models/types/planning-settings';

import templateOnlyComponent from '@ember/component/template-only';

interface BvMethodoIconSignature {
  Args: {
    isProtected?: boolean;
    methodology?: TPlanningMethodology;
    reorderStrategy?: TReorderStrategy;
  };
  Element: HTMLDivElement;
}

const BvMethodoIconComponent = templateOnlyComponent<BvMethodoIconSignature>();

export default BvMethodoIconComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvMethodoIcon: typeof BvMethodoIconComponent;
    'bv-methodo-icon': typeof BvMethodoIconComponent;
  }
}
